// extracted by mini-css-extract-plugin
module.exports = {"biomarkers__header":"styles_biomarkers__header__1fxyH"};